jQuery(document).ready(function(){
  // Initialize Slick Carousel
// Initialize the slick slider for thumbnails
// $('.product-single__thumbnails').slick({
//   slidesToShow: 5,  // Show 5 thumbnails at a time
//   slidesToScroll: 1,  // Scroll 1 thumbnail at a time
//   focusOnSelect: true,  // Focus on the thumbnail when clicked
//   prevArrow: $('.slick-prev'),  // Custom previous arrow button
//   nextArrow: $('.slick-next'),  // Custom next arrow button
//   asNavFor: '.main-thumbnail',  // Sync with the main image
//   infinite: false,  // Disable infinite scrolling to prevent looping
//   responsive: [
//     {
//       breakpoint: 768,  // If screen width is 768px or below
//       settings: {
//         slidesToShow: 3,  // Show 3 thumbnails on smaller screens
//         slidesToScroll: 1,  // Scroll 1 thumbnail at a time
//       }
//     },
//     {
//       breakpoint: 480,  // If screen width is 480px or below
//       settings: {
//         slidesToShow: 2,  // Show 2 thumbnails on very small screens
//         slidesToScroll: 1,  // Scroll 1 thumbnail at a time
//       }
//     }
//   ]
// }).on('init', function() {
//   // Add margin to all slides after initialization
//   $('.product-single__thumbnails .slick-slide').css('margin-right', '25px');

//   // Remove margin from the last slide to avoid extra space on the right side
//   $('.product-single__thumbnails .slick-slide.slick-last').css('margin-right', '0');
// });


  //  jQuery(".slide-test").owlCarousel({
  //   loop: true,
  //   nav: true,
  //   autoplay: true,
  //   autoplayTimeout: 3000,
  //   items: 4,
  //   responsive: {
  //     0: {
  //       items: 1
  //     },
  //     600: {
  //       items: 2
  //     },
  //     1000: {
  //       items: 4
  //     }
  //   }
  // });
});
